module.exports = __webpack_public_path__ + "img/7.c0aef8a0.jpg";